export * from './modify-res.module';
export * from './modify-res';


// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/modify-res/index.ts